import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration - automatically switches between dev and production
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Security: fail fast if Firebase config is missing
const missingKeys = Object.entries(firebaseConfig)
  .filter(([, v]) => !v)
  .map(([k]) => k);
if (missingKeys.length > 0) {
  throw new Error(
    `[firebase] Missing required environment variables: ${missingKeys.join(', ')}. ` +
    `Ensure the correct .env file is present and populated.`
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);

// Firestore emulator (Node smoke tests / local only). Set REACT_APP_FIRESTORE_EMULATOR=true before importing this module.
if (typeof process !== 'undefined' && process.env.REACT_APP_FIRESTORE_EMULATOR === 'true') {
  try {
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
    // eslint-disable-next-line no-console
    console.log('🔥 Firestore emulator (127.0.0.1:8080)');
  } catch (error) {
    const msg = error?.message || String(error);
    if (!msg.includes('already been initialized') && !msg.includes('already connected')) {
      // eslint-disable-next-line no-console
      console.warn('[firebase] Firestore emulator connect:', msg);
    }
  }
}

export default app;
